import Component from '../Component';

export default class SearchPost extends Component {
  constructor() {
    super(...arguments);

    let post = this.props.value.post_id ? this.props.value : null;

    this.state = {
      search_open: !post,
      post_id: post ? post.post_id : null,
      post_type: post ? post.post_type : null,
      posts: null,
      loading: false,
    };

    this.loadSelectedPost();
  }

  render() {
    if (this.isView()) return null;

    return this.state.search_open ? this.renderSearch() : this.renderSelected();
  }

  selectPost(post) {
    if (this.props.onChange) {
      this.props.onChange(post);
    }

    this.setState({
      search_open: false,
      post_id: post.id,
      post_name: post.title,
      post_type: post.subtype,
    });
  }

  startSearch() {
    this.loadSearchResults('');

    this.setState({
      search_open: true,
    });
  }

  cancelSearch() {
    this.setState({
      search_open: false,
    });
  }

  renderSelected() {
    return (
      <div className="components-base-control">
        <div className="components-base-control__field">
          <p>
            <i style={{ textTransform: 'capitalize', marginRight: '5px' }}>
              {this.state.post_type}:
            </i>
            <b>{this.state.post_name}</b> ({this.state.post_id})
          </p>

          <button
            type="button"
            className="button is-button"
            onClick={() => {
              this.startSearch();
            }}
          >
            Switch
          </button>
        </div>
      </div>
    );
  }

  renderSearch() {
    return (
      <div className="components-base-control">
        <div className="components-base-control__field">
          <label className="components-base-control__label">
            {this.props.label || 'Select Post'}
          </label>

          <input
            type="text"
            onChange={event => this.loadSearchResults(event.target.value)}
            className="components-select-control__input"
          />

          {this.state.post_id && (
            <button
              type="button"
              className="button is-button"
              onClick={() => {
                this.cancelSearch();
              }}
            >
              Cancel
            </button>
          )}

          <div className="components-base-control__result">
            {this.renderSearchResults()}
            {this.renderSearchStyleTag()}
          </div>
        </div>
      </div>
    );
  }

  renderSearchStyleTag() {
    return (
      <style
        dangerouslySetInnerHTML={{
          __html: `
.components-SearchPost__Results {
  position: absolute;
  border: 1px solid #7e8993;
  border-radius: 5px;
  background: #fff;
  z-index: 100;
  width: 232px;
  max-height: 345px;
  overflow-y: auto;
}
.components-SearchPost__ResultRow {
  padding: 7px 10px;
  border-bottom: 1px solid #7e8993;
  cursor: pointer;
}
.components-SearchPost__ResultRow:last-child {
  border-bottom: none;
}
.components-SearchPost__ResultRow:hover,
.components-SearchPost__ResultRow:focus,
.components-SearchPost__ResultRow:active {
  background: #f3f5f6;
}
.components-SearchPost__ResultRow__title {
  margin-top: 0;
  margin-bottom: 5px;
}
.components-SearchPost__ResultRow__data {
  margin-bottom: 5px;
  text-transform: capitalize;
}
.components-SearchPost__ResultRow__data__info {
  color: #0073aa;
  margin-right: 7px;
}
    `,
        }}
      />
    );
  }

  renderSearchResults() {
    if (this.state.loading) {
      return <i>Loading...</i>;
    }

    if (!this.state.posts) {
      return <i>Type to search</i>;
    }

    if (this.state.posts.length == 0) {
      return <i>No posts found</i>;
    }

    return (
      <div className="components-SearchPost__Results">
        {this.state.posts.map((post, key) =>
          this.renderSearchResultRow(post, key)
        )}
      </div>
    );
  }

  renderSearchResultRow(post, key) {
    return (
      <div
        key={key}
        className="components-SearchPost__ResultRow"
        onClick={() => this.selectPost(post)}
      >
        <h4 className="components-SearchPost__ResultRow__title">
          {post.title}
        </h4>
        <p className="components-SearchPost__ResultRow__data">
          <span className="components-SearchPost__ResultRow__data__info">
            ID:
          </span>
          {post.id}
        </p>
        <p className="components-SearchPost__ResultRow__data">
          <span className="components-SearchPost__ResultRow__data__info">
            Type:
          </span>
          {post.subtype}
        </p>
        {this.renderSearchResultRowTerms(post)}
      </div>
    );
  }

  renderSearchResultRowTerms(post) {
    if (!post.terms || post.terms.length == 0) {
      return null;
    }

    let components = [];

    for (let taxonomy in post.terms) {
      let terms = post.terms[taxonomy].map(term => term.name);

      if (! terms || terms.length == 0) {
        continue;
      }

      components.push(
        <p className="components-SearchPost__ResultRow__data">
          <span className="components-SearchPost__ResultRow__data__info">
            {taxonomy.replace(/_/g, ' ')}:
          </span>
          {terms.join(', ')}
        </p>
      );
    }

    return components;
  }

  loadSearchResults(search) {
    if (!search || search == '') {
      this.setState({
        posts: null,
      });

      return;
    }

    this.setState({
      loading: true,
    });

    wp.api.loadPromise.done(() => {
      const SearchCollection = wp.api.collections.Search.extend({
        model: (attrs, options) => {
          return new wp.api.WPApiBaseModel(attrs, options);
        },
      });

      new SearchCollection()
        .fetch({
          data: {
            per_page: this.props.per_page || 100,
            subtype: this.props.type || 'any',
            search: search,
            terms: true,
          },
        })
        .done(response => this.setState({ posts: response, loading: false }));
    });
  }

  loadSelectedPost() {
    if (!this.state.post_id || !this.state.post_type) {
      return;
    }

    wp.api.loadPromise.done(() => {
      const api_url =
        global.wpApiSettings && global.wpApiSettings.root
          ? global.wpApiSettings.root
          : '/wp-json/';

      const SearchModel = wp.api.models.Post.extend({
        url:
          api_url + 'wp/v2/' + this.state.post_type + '/' + this.state.post_id,
      });

      new SearchModel().fetch().done(response => {
        if (!response) {
          this.setState({
            post_id: null,
            post_name: null,
            post_type: null,
          });

          this.startSearch();

          return;
        }

        this.setState({
          post_name: response.title.rendered,
          post_type: response.type,
        });
      });
    });
  }
}
